import { lazy } from 'react';

const CompareApplicationsModal = lazy(
  () =>
    import('modules/IndustryPartnerPlacements/modals/CompareApplicationsModal'),
);

const AutoFilterRulesConfigureModal = lazy(
  () =>
    import(
      'modules/IndustryPartnerPlacements/modals/AutoFilterRulesConfigureModal'
    ),
);

export default {
  COMPARE_APPLICATIONS_MODAL: CompareApplicationsModal,
  AUTO_FILTER_RULES_CONFIGURE_MODAL: AutoFilterRulesConfigureModal,
};
